/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { GetAvailableCoursesOptions, GetAvailableCoursesStatus200, GetAvailableCoursesStatus422 } from '../models/GetAvailableCourses'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { getAvailableCourses } from '../clients/axios/getAvailableCourses'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getAvailableCoursesQueryKey = ({ query }: Omit<GetAvailableCoursesOptions, 'headers'> = {}) => [{ url: '/courses/available' }, ...(query ? [query] : [])] as const

type GetAvailableCoursesQueryKey = ReturnType<typeof getAvailableCoursesQueryKey>

export function getAvailableCoursesQueryOptions({ query }: GetAvailableCoursesOptions = {}, config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const queryKey = getAvailableCoursesQueryKey({ query })
  return queryOptions<GetAvailableCoursesStatus200, ResponseErrorConfig<GetAvailableCoursesStatus422>, GetAvailableCoursesStatus200, typeof queryKey>({
   queryKey,
   queryFn: async ({ signal }) => {
      return await getAvailableCourses({ ...config, query, signal: config.signal ?? signal, throwOnError: true })
   },
  })
}

/**
 * @description List all available courses for this org.
 * @summary Get Available Courses
 * {@link /courses/available}
 */
export function useGetAvailableCourses<TData = GetAvailableCoursesStatus200, TQueryData = GetAvailableCoursesStatus200, TQueryKey extends QueryKey = GetAvailableCoursesQueryKey>({ query }: { query?: GetAvailableCoursesOptions['query'] | (() => GetAvailableCoursesOptions['query']) } = {}, options: {
  query?: Partial<QueryObserverOptions<GetAvailableCoursesStatus200, ResponseErrorConfig<GetAvailableCoursesStatus422>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
} = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { query: typeof query === 'function' ? query() : query }
  const queryKey = resolvedOptions?.queryKey ?? getAvailableCoursesQueryKey(resolvedParams)

  const queryResult = useQuery({
   ...getAvailableCoursesQueryOptions(resolvedParams, config),
   ...resolvedOptions,
   queryKey,
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetAvailableCoursesStatus422>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
